import React, { useState, useEffect, useRef } from 'react';
import {Slide, toast, ToastContainer} from "react-toastify";
import audio_finish from '../finish.mp3'
import warn from '../warn.mp3'

export default function WarehouseScanner() {
    // ── Auth ──
    const [scanWorker,   setScanWorker]   = useState(() => {
        try { return JSON.parse(localStorage.getItem('scanner_worker') || 'null'); } catch { return null; }
    });
    const [loginForm,    setLoginForm]    = useState({ username: '', password: '' });
    const [loginLoading, setLoginLoading] = useState(false);
    const [loginError,   setLoginError]   = useState('');

    const [language, setLanguage] = useState('uzb');
    const [showLangMenu, setShowLangMenu] = useState(false);
    const [trackingCode, setTrackingCode] = useState('');
    const [weight, setWeight] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({ trackingCode: '', weight: '' });
    const [clientId, setClientId] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [scanRecords, setScanRecords] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [activeSerial, setActiveSerial] = useState(null);
    const [allSerials,   setAllSerials]   = useState([]);
    const [showHistory,  setShowHistory]  = useState(false);
    const recordsPerPage = 100;

    const trackingInputRef = useRef(null);
    const weightInputRef = useRef(null);
    const clientIdInputRef = useRef(null);
    const searchInputRef = useRef(null);
    const searchTimeoutRef = useRef(null);
    const lastScanTimeRef = useRef(0);
    const isProcessingRef = useRef(false);

    const translations = {
        uzb: {
            langName: "O'zbekcha",
            title: 'Ombor Skaner Tizimi',
            scanPlaceholder: 'Barkodni bu yerga skanerlang...',
            weightPlaceholder: 'Og\'irlikni skanerlang yoki kiriting...',
            submitButton: 'Qabul qilish',
            noRecords: 'Hozircha scan qilinmagan.',
            trackingCodeLabel: 'Trek raqam',
            weightLabel: 'Og\'irligi',
            clientIdLabel: 'Qabul qiluvchi',
            statusLabel: 'Holati',
            statusCreated: 'Yaratilgan',
            statusUpdated: 'Yangilangan',
            timeLabel: 'Qabul qilish sanasi',
            modalTitle: 'Ma\'lumotlarni tasdiqlash',
            clientIdPlaceholder: 'Mijoz ID ni kiriting...',
            cancel: 'Bekor qilish',
            confirm: 'Qabul qilish',
            save: 'Saqlash',
            edit: 'Tahrirlash',
            search: 'Trek raqamni qidirish',
            showing: 'Ko\'rsatilmoqda',
            of: 'dan',
            records: 'yozuv',
            loading: 'Yuklanmoqda...',
            alreadyExists: 'Bu trek kod allaqachon qo\'shilgan!',
            clientIdLength: 'Mijoz ID 6 ta belgidan iborat bo\'lishi kerak',
            successSaved: 'Muvaffaqiyatli saqlandi',
            successUpdated: 'Muvaffaqiyatli yangilandi',
            fillData: 'Ma\'lumotlarni to\'ldiring!',
            deleteConfirm: "Bu trek kodni o'chirishni tasdiqlaysizmi?",
            deleteSuccess: "Muvaffaqiyatli o'chirildi",
            deleteTimeExpired: "Bu trek kod 24 soatdan oldin qabul qilingan, o'chirib bo'lmaydi!",
            deleteLocationBlocked: "UZB, Yetkazib berilmoqda yoki Yetkazib berildi statusidagi trek kodni o'chirib bo'lmaydi!",
            editLocationBlocked: "UZB, Yetkazib berilmoqda yoki Yetkazib berildi statusidagi trek kodni o'zgartirib bo'lmaydi!",
            serverError: 'Xatolik',
            apiError: 'API endpoint noto\'g\'ri. Backend ishga tushirilganmi tekshiring.',
            connectionError: 'Server bilan bog\'lanib bo\'lmadi. Backend ishga tushirilganmi?',
            editTimeExpired: 'Bu trek kod 24 soatdan oldin qabul qilingan, tahrirlash mumkin emas!',
            cannotRescan: 'Bu trek kod allaqachon qabul qilingan! Qayta scaner qilish mumkin emas!',
            partyLabel: 'Partiya',
            historyTitle: 'Oxirgi 5 ta partiya',
            historyPast: 'Tugagan',
            lastDayText: 'Oxirgi kun!',
            oldPartyText: 'Eski partiya!',
            loginTitle: 'Tizimga kirish',
            loginUsername: 'Login',
            loginPassword: 'Parol',
            loginBtn: 'Kirish',
            loginError: "Login yoki parol noto'g'ri",
            logout: 'Chiqish',
            workerLabel: 'Operator',
        },
        rus: {
            langName: 'Русский',
            title: 'Система складского сканера',
            scanPlaceholder: 'Отсканируйте штрих-код здесь...',
            weightPlaceholder: 'Отсканируйте или введите вес...',
            submitButton: 'Принять',
            noRecords: 'Записей пока нет.',
            trackingCodeLabel: 'Трек-номер',
            weightLabel: 'Вес',
            clientIdLabel: 'Получатель',
            statusLabel: 'Статус',
            statusCreated: 'Создан',
            statusUpdated: 'Обновлен',
            timeLabel: 'Дата приема',
            modalTitle: 'Подтверждение данных',
            clientIdPlaceholder: 'Введите ID клиента...',
            cancel: 'Отмена',
            confirm: 'Принять',
            save: 'Сохранить',
            edit: 'Редактировать',
            search: 'Поиск по трек-номеру',
            showing: 'Показано',
            of: 'из',
            records: 'записей',
            loading: 'Загрузка...',
            alreadyExists: 'Этот трек-код уже добавлен!',
            clientIdLength: 'ID клиента должен состоять из 6 символов',
            successSaved: 'Успешно сохранено',
            successUpdated: 'Успешно обновлено',
            fillData: 'Заполните данные!',
            deleteConfirm: 'Вы уверены, что хотите удалить этот трек-код?',
            deleteSuccess: 'Успешно удалено',
            deleteTimeExpired: 'Удаление невозможно: прошло более 24 часов!',
            deleteLocationBlocked: 'Нельзя удалить трек-код со статусом В Узбекистане, В пути или Доставлено!',
            editLocationBlocked: 'Нельзя редактировать трек-код со статусом В Узбекистане, В пути или Доставлено!',
            serverError: 'Ошибка',
            apiError: 'Неверный API endpoint. Проверьте, запущен ли Backend.',
            connectionError: 'Не удалось связаться с сервером. Backend запущен?',
            editTimeExpired: 'Этот трек-код был принят более 24 часов назад, редактирование невозможно!',
            cannotRescan: 'Этот трек-код уже принят! Повторное сканирование невозможно!',
            partyLabel: 'Партия',
            historyTitle: 'Последние 5 партий',
            historyPast: 'Завершена',
            lastDayText: 'Последний день!',
            oldPartyText: 'Старая партия!',
            loginTitle: 'Вход в систему',
            loginUsername: 'Логин',
            loginPassword: 'Пароль',
            loginBtn: 'Войти',
            loginError: 'Неверный логин или пароль',
            logout: 'Выйти',
            workerLabel: 'Оператор',
        },
        chn: {
            langName: '中国人',
            title: '仓库扫描系统',
            scanPlaceholder: '在此扫描条形码...',
            weightPlaceholder: '扫描或输入重量...',
            submitButton: '接受',
            noRecords: '暂无记录。',
            trackingCodeLabel: '跟踪号码',
            weightLabel: '重量',
            clientIdLabel: '收件人',
            statusLabel: '状态',
            statusCreated: '已创建',
            statusUpdated: '已更新',
            timeLabel: '接收日期',
            modalTitle: '确认数据',
            clientIdPlaceholder: '输入客户ID...',
            cancel: '取消',
            confirm: '接受',
            save: '保存',
            edit: '编辑',
            search: '搜索跟踪号码',
            showing: '显示',
            of: '的',
            records: '记录',
            loading: '加载中...',
            alreadyExists: '此跟踪代码已添加！',
            clientIdLength: '客户ID必须为6个字符',
            successSaved: '成功保存',
            successUpdated: '成功更新',
            fillData: '请填写数据！',
            deleteConfirm: '确认删除此跟踪码？',
            deleteSuccess: '成功删除',
            deleteTimeExpired: '无法删除：已超过24小时！',
            deleteLocationBlocked: '无法删除：状态为在乌兹别克斯坦、运输中或已送达！',
            editLocationBlocked: '无法编辑：状态为在乌兹别克斯坦、运输中或已送达！',
            serverError: '错误',
            apiError: 'API端点不正确。请检查Backend是否运行。',
            connectionError: '无法连接到服务器。Backend运行了吗？',
            editTimeExpired: '此跟踪代码已超过24小时，无法编辑！',
            cannotRescan: '此跟踪代码已存在！无法重复扫描！',
            partyLabel: '批次',
            historyTitle: '最近5个批次',
            historyPast: '已结束',
            lastDayText: '最后一天！',
            oldPartyText: '旧批次！',
            loginTitle: '登录系统',
            loginUsername: '用户名',
            loginPassword: '密码',
            loginBtn: '登录',
            loginError: '用户名或密码错误',
            logout: '退出',
            workerLabel: '操作员',
        },
        eng: {
            langName: 'English',
            title: 'Warehouse Scanner System',
            scanPlaceholder: 'Scan barcode here...',
            weightPlaceholder: 'Scan or enter weight...',
            submitButton: 'Accept',
            noRecords: 'No records yet.',
            trackingCodeLabel: 'Track Number',
            weightLabel: 'Weight',
            clientIdLabel: 'Recipient',
            statusLabel: 'Status',
            statusCreated: 'Created',
            statusUpdated: 'Updated',
            timeLabel: 'Acceptance Date',
            modalTitle: 'Confirm Data',
            clientIdPlaceholder: 'Enter Client ID...',
            cancel: 'Cancel',
            confirm: 'Accept',
            save: 'Save',
            edit: 'Edit',
            search: 'Search track number',
            showing: 'Showing',
            of: 'of',
            records: 'records',
            loading: 'Loading...',
            alreadyExists: 'This tracking code has already been added!',
            clientIdLength: 'Client ID must be 6 characters long',
            successSaved: 'Successfully saved',
            successUpdated: 'Successfully updated',
            fillData: 'Please fill in the data!',
            deleteConfirm: 'Are you sure you want to delete this tracking code?',
            deleteSuccess: 'Successfully deleted',
            deleteTimeExpired: 'Cannot delete: more than 24 hours have passed!',
            deleteLocationBlocked: 'Cannot delete: tracking code is in UZB, On the way, or Delivered status!',
            editLocationBlocked: 'Cannot edit: tracking code is in UZB, On the way, or Delivered status!',
            serverError: 'Error',
            apiError: 'Incorrect API endpoint. Check if Backend is running.',
            connectionError: 'Could not connect to server. Is Backend running?',
            editTimeExpired: 'This tracking code was scanned more than 24 hours ago, editing is not allowed!',
            cannotRescan: 'This tracking code already exists! Cannot scan again!',
            partyLabel: 'Party',
            historyTitle: 'Last 5 batches',
            historyPast: 'Completed',
            lastDayText: 'Last day!',
            oldPartyText: 'Old party!',
            loginTitle: 'Login',
            loginUsername: 'Username',
            loginPassword: 'Password',
            loginBtn: 'Sign in',
            loginError: 'Invalid username or password',
            logout: 'Logout',
            workerLabel: 'Operator',
        }
    };

    const t = translations[language];
    const langFlags = { uzb: '🇺🇿', rus: '🇷🇺', chn: '🇨🇳', eng: '🇺🇸' };
    const API_BASE_URL = 'https://fx.softmakon.uz/api/v1';
    const TRACKING_SERIAL_URL = 'https://fx.softmakon.uz/api/tracking-serial/';

    const todayStr = () => new Date().toISOString().slice(0, 10);
    const fmtDateShort = (iso) => {
        if (!iso) return '';
        const [y, m, d] = iso.split('-');
        return `${d}.${m}.${y}`;
    };
    const isLastDay = (s) => s?.dateto === todayStr();

    const API_SCANNER = 'https://fx.softmakon.uz/api';

    // Auth header
    const authHeader = () => scanWorker?.token
        ? { 'Authorization': `Scanner ${scanWorker.token}` }
        : {};

    const doLogin = async (e) => {
        e.preventDefault();
        setLoginLoading(true);
        setLoginError('');
        try {
            const r = await fetch(`${API_SCANNER}/scanner-login/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(loginForm),
            });
            const data = await r.json();
            if (!r.ok) { setLoginError(data.error || t.loginError); return; }
            const worker = { token: data.token, username: data.username, is_admin: data.is_admin };
            localStorage.setItem('scanner_worker', JSON.stringify(worker));
            setScanWorker(worker);
        } catch {
            setLoginError(t.loginError);
        } finally {
            setLoginLoading(false);
        }
    };

    const doLogout = () => {
        localStorage.removeItem('scanner_worker');
        setScanWorker(null);
        setScanRecords([]);
    };

    // Audio ovozlarini chalish
    const playSuccessSound = () => {
        const audio = new Audio(audio_finish);
        audio.play().catch(err => console.log('Audio play error:', err));
    };

    const playErrorSound = () => {
        const audio = new Audio(warn);
        audio.play().catch(err => console.log('Audio play error:', err));
    };

    const fetchActiveSerial = async () => {
        try {
            const today = new Date().toISOString().slice(0, 10);
            const r = await fetch(TRACKING_SERIAL_URL);
            if (!r.ok) return;
            const data = await r.json();
            const list = Array.isArray(data) ? data : (data.results || []);
            const sorted = [...list].sort((a, b) => (b.datefrom || '').localeCompare(a.datefrom || ''));
            setAllSerials(sorted);
            const active = list.find(s => s.datefrom <= today && s.dateto >= today);
            setActiveSerial(active || null);
        } catch {}
    };

    // Tashqarida bosib tarix panelini yopish
    React.useEffect(() => {
        if (!showHistory) return;
        const handler = (e) => {
            if (!e.target.closest('.serial-history-root')) setShowHistory(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [showHistory]);

    const fetchTrackingRecords = async (page = 1, search = '') => {
        setLoading(true);
        try {
            let url = `${API_BASE_URL}/trackingread/?page=${page}&page_size=${recordsPerPage}`;
            if (search.trim()) url += `&search=${encodeURIComponent(search.trim())}`;

            const response = await fetch(url, { headers: authHeader() });

            // Check if response is HTML (error page)
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                console.error('API endpoint topilmadi yoki noto\'g\'ri:', url);
                toast.error(t.apiError, {
                    position: "top-right",
                    transition: Slide,
                    autoClose: 5000
                });
                return;
            }

            if (!response.ok) {
                throw new Error(`Server xatosi: ${response.status}`);
            }

            const data = await response.json();
            setScanRecords(data.results || []);
            setTotalPages(data.total_pages || 0);
            setTotalCount(data.count || 0);
            setCurrentPage(page);

            // Search qilgandan keyin focusni qaytarish
            setTimeout(() => {
                if (searchInputRef.current && search.trim()) {
                    searchInputRef.current.focus();
                }
            }, 50);
        } catch (error) {
            console.error('Fetch error:', error);
            if (error.message.includes('Failed to fetch')) {
                toast.error(t.connectionError, {
                    position: "top-right",
                    transition: Slide,
                    autoClose: 5000
                });
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchActiveSerial();
        if (scanWorker) fetchTrackingRecords(1);
    }, [scanWorker]);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            fetchTrackingRecords(1, value);
        }, 500);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            fetchTrackingRecords(newPage, searchQuery);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Format status for display - check if updated or created
    const getStatusBadge = (record) => {
        if (!record.createdAt || !record.scannerUpdatedAt) {
            return { text: t.statusCreated, color: 'bg-blue-100 text-blue-800' };
        }

        const created = new Date(record.createdAt).getTime();
        const scannerUpdated = new Date(record.scannerUpdatedAt).getTime();

        // If difference is more than 1 second, it's updated
        if (Math.abs(scannerUpdated - created) > 1000) {
            return { text: t.statusUpdated, color: 'bg-orange-100 text-orange-800' };
        }

        return { text: t.statusCreated, color: 'bg-blue-100 text-blue-800' };
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleString('en-GB', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: false
        }).replace(',', '');
    };

    useEffect(() => { trackingInputRef.current?.focus(); }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (showLangMenu && !e.target.closest('.lang-selector')) setShowLangMenu(false);
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [showLangMenu]);

    const handleTrackingKeyDown = (e) => {
        if (e.key === 'Enter' && !isProcessingRef.current) {
            e.preventDefault();
            if (!trackingCode.trim()) return;
            const now = Date.now();
            lastScanTimeRef.current = now;
            weightInputRef.current?.focus();
        }
    };

    const handleWeightKeyDown = (e) => {
        if (e.key === 'Enter' && !isProcessingRef.current) {
            e.preventDefault();
            if (!weight.trim()) return;
            isProcessingRef.current = true;
            openModal();
            setTimeout(() => { isProcessingRef.current = false; }, 500);
        }
    };

    const handleManualSubmit = () => {
        if (!trackingCode.trim() || !weight.trim()) {
            toast.warning(t.fillData, {
                position: "top-right",
                transition: Slide,
                autoClose: 3000
            });
            return;
        }
        openModal();
    };

    const openModal = () => {
        setModalData({ trackingCode: trackingCode.trim(), weight: weight.trim() });
        setShowModal(true);
        setClientId('');
        setEditMode(false);
        setEditingRecord(null);
    };

    const handleDelete = async (record) => {
        // China bo'lmagan statuslar o'chirib bo'lmaydi
        const PROTECTED_LOCATIONS = ['uzb', 'ontheway', 'delivered'];
        if (PROTECTED_LOCATIONS.includes(record.location)) {
            toast.error(t.deleteLocationBlocked, { position: "top-right", transition: Slide, autoClose: 4000 });
            playErrorSound(); return;
        }
        const scanTime = new Date(record.scannerUpdatedAt || record.createdAt).getTime();
        if ((Date.now() - scanTime) / (1000 * 60 * 60) > 24) {
            toast.error(t.deleteTimeExpired, { position: "top-right", transition: Slide, autoClose: 4000 });
            playErrorSound(); return;
        }
        if (!window.confirm(t.deleteConfirm)) return;
        try {
            const r = await fetch(`${API_BASE_URL}/trackingid/delete/${record.id}/`, { method: 'DELETE' });
            if (!r.ok) throw new Error('Server xatosi');
            toast.success(t.deleteSuccess, { position: "top-right", transition: Slide, autoClose: 3000 });
            playSuccessSound();
            fetchTrackingRecords(currentPage, searchQuery);
        } catch (error) {
            toast.error(`${t.serverError}: ${error.message}`, { position: "top-right", transition: Slide, autoClose: 3000 });
            playErrorSound();
        }
    };

    const openEditModal = (record) => {
        // 24 soat o'tganligini tekshirish
        const scanTime = new Date(record.scannerUpdatedAt || record.createdAt).getTime();
        const now = Date.now();
        const hoursPassed = (now - scanTime) / (1000 * 60 * 60);

        if (hoursPassed > 24) {
            toast.error(t.editTimeExpired, {
                position: "top-right",
                transition: Slide,
                autoClose: 4000
            });
            playErrorSound();
            return;
        }

        setModalData({
            trackingCode: record.trackingNumber,
            weight: record.weight
        });
        setClientId(record.clientCode);
        setEditingRecord(record);
        setEditMode(true);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setModalData({ trackingCode: '', weight: '' });
        setClientId('');
        setEditMode(false);
        setEditingRecord(null);
        setTrackingCode('');
        setWeight('');
        // Don't focus immediately, let body scroll restore first
        setTimeout(() => {
            if (trackingInputRef.current) {
                trackingInputRef.current.focus();
            }
        }, 300);
    };

    const validateClientId = async (clientCode) => {
        try {
            const response = await fetch(`${API_BASE_URL}/userid/?client_id=${clientCode}`);
            if (!response.ok) return '000444';
            const data = await response.json();
            if (data && data.client_id) return data.client_id;
            if (Array.isArray(data) && data.length > 0 && data[0].client_id) return data[0].client_id;
            return '000444';
        } catch (error) {
            return '000444';
        }
    };

    const handleSubmit = async () => {
        // Mijoz ID tekshiruvi - 6 ta belgidan iborat bo'lishi kerak
        if (clientId.length !== 6) {
            toast.error(t.clientIdLength, {
                position: "top-right",
                transition: Slide,
                autoClose: 3000
            });
            playErrorSound();
            return;
        }

        // Trek kod dublikatini tekshirish (faqat create da)
        if (!editMode) {
            const isDuplicate = scanRecords.some(record =>
                record.trackingNumber.toLowerCase() === modalData.trackingCode.toLowerCase()
            );

            if (isDuplicate) {
                toast.error(t.cannotRescan, {
                    position: "top-right",
                    transition: Slide,
                    autoClose: 4000
                });
                playErrorSound();
                return;
            }
        }

        // Edit mode da 24 soat tekshiruvi
        if (editMode && editingRecord) {
            const scanTime = new Date(editingRecord.scannerUpdatedAt || editingRecord.createdAt).getTime();
            const now = Date.now();
            const hoursPassed = (now - scanTime) / (1000 * 60 * 60);

            if (hoursPassed > 24) {
                toast.error(t.editTimeExpired, {
                    position: "top-right",
                    transition: Slide,
                    autoClose: 4000
                });
                playErrorSound();
                closeModal();
                return;
            }
        }

        setIsSaving(true);

        const validatedClientId = await validateClientId(clientId.trim());

        try {
            const apiData = {
                trackingNumber: modalData.trackingCode,
                clientCode: validatedClientId,
                weight: parseFloat(modalData.weight) || 0
            };

            // Add additional fields if editing
            if (editMode && editingRecord) {
                apiData.companyId = editingRecord.companyId;
                apiData.status = editingRecord.status;
                apiData.remark = editingRecord.remark;
                apiData.packingType = editingRecord.packingType;
                apiData.boxId = editingRecord.boxId;
            }

            // Edit yoki Create endpoint ni tanlash
            const endpoint = editMode
                ? `${API_BASE_URL}/trackingid/update/${editingRecord.id}/`
                : `${API_BASE_URL}/trackingid/create/`;

            const method = editMode ? 'PUT' : 'POST';

            const response = await fetch(endpoint, {
                method: method,
                headers: { 'Content-Type': 'application/json', ...authHeader() },
                body: JSON.stringify(apiData)
            });

            if (!response.ok) throw new Error('Server xatosi');

            const result = await response.json();
            console.log(editMode ? '✅ Yangilandi' : '✅ Yaratildi', result);

            toast.success(editMode ? t.successUpdated : t.successSaved, {
                position: "top-right",
                transition: Slide,
                autoClose: 3000
            });
            playSuccessSound();
            closeModal();
            fetchTrackingRecords(currentPage, searchQuery);
        } catch (error) {
            toast.error(`${t.serverError}: ${error.message}`, {
                position: "top-right",
                transition: Slide,
                autoClose: 3000
            });
            playErrorSound();
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        if (showModal && clientIdInputRef.current) clientIdInputRef.current.focus();
    }, [showModal]);

    // Prevent body scroll when modal is open
    useEffect(() => {
        if (showModal) {
            // Save current scroll position
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
        } else {
            // Restore scroll position
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }
    }, [showModal]);

    const canSubmit = trackingCode.trim() && weight.trim();

    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= 4; i++) pages.push(i);
                pages.push('...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...');
                for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return pages;
    };

    // ── Login ekrani ──────────────────────────────────────────────────────────
    if (!scanWorker) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
                <ToastContainer />
                <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm">
                    <h1 className="text-2xl font-bold text-gray-800 mb-2 text-center">{t.loginTitle}</h1>
                    <p className="text-gray-400 text-sm text-center mb-6">{t.title}</p>
                    <form onSubmit={doLogin} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">{t.loginUsername}</label>
                            <input
                                type="text"
                                value={loginForm.username}
                                onChange={e => setLoginForm(f => ({ ...f, username: e.target.value }))}
                                className="w-full px-4 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                autoFocus
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">{t.loginPassword}</label>
                            <input
                                type="password"
                                value={loginForm.password}
                                onChange={e => setLoginForm(f => ({ ...f, password: e.target.value }))}
                                className="w-full px-4 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                required
                            />
                        </div>
                        {loginError && (
                            <p className="text-red-600 text-sm text-center">{loginError}</p>
                        )}
                        <button
                            type="submit"
                            disabled={loginLoading}
                            className="w-full py-2.5 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50"
                        >
                            {loginLoading ? t.loading : t.loginBtn}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">
            <ToastContainer />
            <div className="bg-white border-b border-gray-200 px-6 py-4">
                <div className="max-w-7xl mx-auto flex justify-between items-center">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">{t.title}</h1>
                        <p className="text-xs text-gray-400 mt-0.5">
                            {t.workerLabel}: <span className="font-semibold text-blue-600">{scanWorker.username}</span>
                            {scanWorker.is_admin && <span className="ml-1 text-xs text-purple-600">(admin)</span>}
                        </p>
                    </div>
                    <div className="flex items-center gap-3">
                        <button onClick={doLogout}
                                className="px-3 py-1.5 text-sm border border-red-300 text-red-600 rounded-lg hover:bg-red-50">
                            {t.logout}
                        </button>
                        {activeSerial && (() => {
                            const today = todayStr();
                            const isActive = activeSerial.datefrom <= today && activeSerial.dateto >= today;
                            const isLast   = isLastDay(activeSerial);
                            return (
                                <div className="relative serial-history-root">
                                    <button
                                        onClick={() => setShowHistory(v => !v)}
                                        className={`flex flex-col items-start px-3 py-1.5 rounded-lg border cursor-pointer hover:opacity-80 text-left
                                            ${isLast ? 'bg-red-50 border-red-300' : isActive ? 'bg-blue-50 border-blue-200' : 'bg-orange-50 border-orange-200'}`}
                                    >
                                        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{t.partyLabel}</span>
                                        <span className={`text-base font-bold leading-tight ${isLast ? 'text-red-700' : isActive ? 'text-blue-700' : 'text-orange-600'}`}>
                                            {activeSerial.title || activeSerial.serial_number} - {activeSerial.more_text}
                                        </span>
                                        <span className={`text-xs font-semibold mt-0.5 ${isLast ? 'text-red-600' : isActive ? 'text-green-700' : 'text-orange-500'}`}>
                                            {fmtDateShort(activeSerial.datefrom)} — {fmtDateShort(activeSerial.dateto)}
                                            {isLast   && <span className="ml-1"> — {t.lastDayText}</span>}
                                            {!isActive && <span className="ml-1"> — {t.oldPartyText}</span>}
                                        </span>
                                    </button>

                                    {showHistory && (
                                        <div className="absolute right-0 top-full mt-2 w-72 bg-white rounded-xl shadow-2xl border border-gray-200 z-50 overflow-hidden">
                                            <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
                                                <span className="font-bold text-gray-800 text-sm">{t.historyTitle}</span>
                                                <button onClick={() => setShowHistory(false)} className="text-gray-400 hover:text-gray-600">
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                                                    </svg>
                                                </button>
                                            </div>
                                            <div className="divide-y divide-gray-100">
                                                {allSerials
                                                    .filter(s => s.dateto < todayStr())
                                                    .slice(0, 5)
                                                    .map((s, i) => {
                                                        const sn = s.title || s.serial_number;
                                                        return (
                                                            <div key={sn || i} className="px-4 py-3">
                                                                <div className="flex items-center flex-wrap">
                                                                    <span className="font-bold text-gray-900 text-sm">{sn} - {s.more_text}</span>
                                                                </div>
                                                                <div className="text-xs text-gray-500 mt-0.5">
                                                                    {fmtDateShort(s.datefrom)} — {fmtDateShort(s.dateto)}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })()}
                        <div className="relative lang-selector">
                            <button
                                onClick={() => setShowLangMenu(!showLangMenu)}
                                className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                            >
                                <span className="text-2xl">{langFlags[language]}</span>
                                <span className="font-medium text-gray-700">{language.toUpperCase()}</span>
                                <svg className={`w-4 h-4 text-gray-500 transition-transform ${showLangMenu ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {showLangMenu && (
                                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                                    {['uzb', 'rus', 'eng', 'chn'].map(lang => (
                                        <button
                                            key={lang}
                                            onClick={() => { setLanguage(lang); setShowLangMenu(false); }}
                                            className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 ${language === lang ? 'bg-blue-50' : ''}`}
                                        >
                                            <span className="text-2xl">{langFlags[lang]}</span>
                                            <span className={`font-medium ${language === lang ? 'text-blue-600' : 'text-gray-700'}`}>
                      {translations[lang].langName}
                    </span>
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto p-6">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <div className="flex items-center gap-4">
                        <div className="flex-1">
                            <input
                                ref={trackingInputRef}
                                type="text"
                                value={trackingCode}
                                onChange={(e) => setTrackingCode(e.target.value)}
                                onKeyDown={handleTrackingKeyDown}
                                placeholder={t.scanPlaceholder}
                                disabled={showModal}
                                maxLength={50}
                                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div className="w-64">
                            <input
                                ref={weightInputRef}
                                type="text"
                                value={weight}
                                onChange={(e) => setWeight(e.target.value)}
                                onKeyDown={handleWeightKeyDown}
                                placeholder={t.weightPlaceholder}
                                disabled={showModal}
                                maxLength={20}
                                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <button
                            onClick={() => { setTrackingCode(''); setWeight(''); trackingInputRef.current?.focus(); }}
                            className="p-3 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg"
                            disabled={showModal}
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        {canSubmit && !showModal && (
                            <button onClick={handleManualSubmit} className="px-8 py-3 bg-gray-700 text-white rounded-lg hover:bg-gray-800 font-medium">
                                {t.submitButton}
                            </button>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
                    <div className="relative">
                        <input
                            ref={searchInputRef}
                            type="text"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder={t.search}
                            className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        {loading && (
                            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    {loading && scanRecords.length === 0 ? (
                        <div className="p-16 text-center">
                            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto mb-4"></div>
                            <p className="text-lg text-gray-600">{t.loading}</p>
                        </div>
                    ) : scanRecords.length === 0 ? (
                        <div className="p-16 text-center text-gray-500">
                            <p className="text-lg">{t.noRecords}</p>
                        </div>
                    ) : (
                        <>
                            <table className="w-full">
                                <thead>
                                <tr className="bg-blue-50 border-b">
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase">{t.trackingCodeLabel}</th>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase">{t.weightLabel}</th>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase">{t.clientIdLabel}</th>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase">{t.statusLabel}</th>
                                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase">{t.timeLabel}</th>
                                </tr>
                                </thead>
                                <tbody className="divide-y">
                                {scanRecords.map((record) => {
                                    const status = getStatusBadge(record);
                                    const scanTime = new Date(record.scannerUpdatedAt || record.createdAt).getTime();
                                    const now = Date.now();
                                    const hoursPassed = (now - scanTime) / (1000 * 60 * 60);
                                    const PROTECTED_LOCATIONS = ['uzb', 'ontheway', 'delivered'];
                                    const isProtected = PROTECTED_LOCATIONS.includes(record.location);
                                    const canEdit = hoursPassed <= 24 && !isProtected;
                                    const canDelete = canEdit;

                                    return (
                                        <tr key={record.id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4">
                                                <div className="flex items-center gap-3">
                                                    <button
                                                        onClick={() => canEdit && openEditModal(record)}
                                                        disabled={!canEdit}
                                                        className={`transition-colors ${
                                                            canEdit
                                                                ? 'text-gray-400 hover:text-blue-600 cursor-pointer'
                                                                : 'text-gray-300 cursor-not-allowed opacity-50'
                                                        }`}
                                                        title={canEdit ? t.edit : isProtected ? t.editLocationBlocked : t.editTimeExpired}
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => canDelete && handleDelete(record)}
                                                        disabled={!canDelete}
                                                        className={`transition-colors ${canDelete ? 'text-gray-400 hover:text-red-600 cursor-pointer' : 'text-gray-300 cursor-not-allowed opacity-50'}`}
                                                        title={canDelete ? "O\'chirish" : PROTECTED_LOCATIONS.includes(record.location) ? t.deleteLocationBlocked : t.deleteTimeExpired}
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                    <span className="text-sm font-medium text-blue-600">{record.trackingNumber}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-900">{record.weight}</td>
                                            <td className="px-6 py-4 text-sm text-blue-600">{record.clientCode}</td>
                                            <td className="px-6 py-4">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${status.color}`}>
                            {status.text}
                          </span>
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-500">
                                                {formatDate(record.scannerUpdatedAt || record.createdAt)}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                            {totalPages > 1 && (
                                <div className="bg-gray-50 px-6 py-4 border-t flex justify-between items-center">
                                    <div className="text-sm text-gray-700">
                                        {t.showing} {((currentPage - 1) * recordsPerPage) + 1} - {Math.min(currentPage * recordsPerPage, totalCount)} {t.of} {totalCount} {t.records}
                                    </div>
                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className="px-3 py-1.5 border rounded-lg disabled:opacity-50"
                                        >
                                            ←
                                        </button>
                                        {getPageNumbers().map((page, i) => (
                                            page === '...' ? <span key={i} className="px-3 py-1.5">...</span> :
                                                <button key={i} onClick={() => handlePageChange(page)} className={`px-3 py-1.5 rounded-lg ${currentPage === page ? 'bg-blue-600 text-white' : 'border'}`}>{page}</button>
                                        ))}
                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="px-3 py-1.5 border rounded-lg disabled:opacity-50"
                                        >
                                            →
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>

            {showModal && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto"
                    onClick={(e) => {
                        // Close modal if clicked outside
                        if (e.target === e.currentTarget) {
                            closeModal();
                        }
                    }}
                >
                    <div
                        className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full my-8"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="text-2xl font-bold mb-6">
                            {editMode ? t.edit : t.modalTitle}
                        </h2>
                        <div className="space-y-4 mb-6">
                            <div>
                                <label className="block text-sm font-medium mb-2">{t.trackingCodeLabel}</label>
                                <input
                                    type="text"
                                    value={modalData.trackingCode}
                                    onChange={(e) => editMode && setModalData({...modalData, trackingCode: e.target.value})}
                                    onKeyDown={(e) => { if (e.key === 'Enter' && clientId.length === 6) handleSubmit(); }}
                                    disabled={!editMode}
                                    className={`w-full px-4 py-2.5 border rounded-lg ${editMode ? 'border-blue-500' : 'bg-gray-50'}`}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">{t.weightLabel}</label>
                                <input
                                    type="text"
                                    value={modalData.weight}
                                    onChange={(e) => setModalData({...modalData, weight: e.target.value})}
                                    onKeyDown={(e) => { if (e.key === 'Enter' && clientId.length === 6) handleSubmit(); }}
                                    className="w-full px-4 py-2.5 border rounded-lg border-blue-500"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-2">{t.clientIdLabel}</label>
                                <input
                                    ref={clientIdInputRef}
                                    type="text"
                                    value={clientId}
                                    onChange={(e) => setClientId(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === 'Enter' && clientId.length === 6) handleSubmit(); }}
                                    placeholder={t.clientIdPlaceholder}
                                    maxLength={6}
                                    className="w-full px-4 py-2.5 border-2 border-blue-500 rounded-lg focus:outline-none focus:ring-2"
                                />
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <button
                                onClick={closeModal}
                                disabled={isSaving}
                                className="flex-1 px-4 py-2.5 border-2 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {t.cancel}
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={clientId.length !== 6 || isSaving}
                                className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                            >
                                {isSaving ? t.loading : (editMode ? t.save : t.confirm)}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}